import { FavoritesSchema } from 'src/models/favorites/schema';
import { Left, Right } from 'src/utils/either';
import { errorMessage } from 'src/utils/errorMessage';
import { mixpanel } from 'src/utils/mixpanel';
import { shoppingApiBaseUrl } from 'src/utils/shoppingApiBaseUrl';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { deleteRequest, getRequest, postRequest } from '../wa/gateways/api/wamazingApi';
import { ApiResponse } from './response/ApiResponse';

const fetchFavorites = async (): Promise<ApiResponse<FavoritesSchema[]>> => {
  try {
    const favorites = await getRequest<{ favList: FavoritesSchema[] }>({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/favorite_products',
    });
    return new Right(favorites.favList);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

const postFavorite = async (
  params: FavoritesSchema[],
  clickedSection: string,
): Promise<ApiResponse<FavoritesSchema[]>> => {
  try {
    await postRequest({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/favorite_products',
      params: {
        favList: params,
      },
    });
    mixpanel.onProductAddedToWishList(
      params.flatMap((p) => p.productId),
      clickedSection,
    );
    return new Right(params);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

type productIds = {
  productId: number;
};

const deleteFavorite = async (params: productIds[]): Promise<ApiResponse<productIds[]>> => {
  try {
    await deleteRequest({
      baseURI: shoppingApiBaseUrl(getLocaleFromUrl()),
      path: '/api/v1/favorite_products',
      params: {
        favList: params,
      },
    });
    mixpanel.onProductDeletedFromWishList(params.flatMap((p) => p.productId));
    return new Right(params);
  } catch (e) {
    return new Left({ errors: [errorMessage(e)] });
  }
};

export { deleteFavorite, fetchFavorites, postFavorite };
